import AbstractProvidedClass from "../shared/AbstractProvidedClass";

export default class Label extends AbstractProvidedClass {
    parent = null;
    cutOff = 50;

    constructor(provider, data = {}) {
        super(provider);
        this.labels = data.labels ?? [];
        this.absX = data.labelX ?? 0;
        this.absY = data.labelY ?? 0;
    }

    setParent(parent) {
        this.parent = parent;
        this.updatePosition();
    }

    display(currentSize, rotation = 0) {
        if (!this.settings.showLabels || this.labels.length == 0 || currentSize < this.cutOff) {
            return;
        }
        this.p.push();
        this.p.translate(this.parent.center.currentX, this.parent.center.currentY);
        this.p.fill(0, this.p.map(currentSize, 500, 1500, 255, 100, true));
        this.p.noStroke();
        this.p.textAlign(this.p.CENTER, this.p.CENTER);
        this.p.textSize(this.p.map(currentSize, 20, 1000, 10, 24));
        this.p.rectMode(this.p.CENTER);
        this.p.text(
            this.getLabels(currentSize).join('\n'),
            this.distance * this.view.scale * Math.cos(this.angle + rotation),
            this.distance * this.view.scale * Math.sin(this.angle + rotation)
        );
        this.p.pop();
    }

    hovered(viewX, viewY) {
        if (!this.settings.showLabels || this.settings.lockLabels || this.labels.length == 0 || this.parent.currentMaxSize < this.cutOff) {
            return false;
        }
        this.p.noStroke();
        this.p.textSize(this.p.map(this.parent.currentMaxSize, 20, 1000, 10, 24));
        let h = (this.p.textAscent() + this.p.textDescent()) * 0.9;
        let labels = this.getLabels(this.parent.currentMaxSize);
        let labelCount = labels.length;
        return !!labels.find((l, i) => {
            let w = this.p.textWidth(l);
            let baseline;
            if (viewX || viewY) {
                baseline = this.currentY + h * i;
            } else {
                baseline = this.parent.center.currentY + this.currentY + h * i;
            }
            if (labelCount == 2) {
                baseline -= h / 2;
            } else if (labelCount == 3) {
                baseline -= h;
            }
            if (viewX || viewY) {
                return viewX >= this.currentX - w / 2
                    && viewX <= this.currentX + w / 2
                    && viewY >= baseline - h / 2
                    && viewY <= baseline + h / 2;
            }
            return this.view.currentX >= this.parent.center.currentX + this.currentX - w / 2
                && this.view.currentX <= this.parent.center.currentX + this.currentX + w / 2
                && this.view.currentY >= baseline - h / 2
                && this.view.currentY <= baseline + h / 2;
        });
    }

    mouseOver(viewX, viewY) {
        if (this.hovered(viewX, viewY)) {
            this.cursor.move();
            return true;
        }
        return false;
    }

    drag(dx, dy) {
        this.move(dx, dy);
    }

    move(dx, dy) {
        this.absX += dx;
        this.absY += dy;
        this.updatePosition();
    }

    updatePosition() {
        this.distance = this.p.dist(
            0,
            0,
            this.absX,
            this.absY
        );
        this.angle = this.p.atan2(
            this.absY,
            this.absX
        );
    }

    setValue(index, value) {
        this.labels[index] = value;
        return this;
    }

    clone() {
        return new Label(
            this.provider,
            {
                labels: Array.from(this.labels),
                labelX: this.absX,
                labelY: this.absY,
            }
        );
    }

    export() {
        return {
            labels: this.labels,
            labelX: this.absX,
            labelY: this.absY,
        }
    }

    getLabels(currentSize) {
        return this.labels.filter(l => l).slice(0, this.p.floor(this.p.map(currentSize, this.cutOff, 100, 1, 3)));
    }

    hasLabels() {
        return this.labels.filter(l => l).length > 0;
    }

    get currentX() {
        return this.absX * this.view.scale;
    }

    get currentY() {
        return this.absY * this.view.scale;
    }

    get first() {
        return this.labels.at(0) ?? '';
    }

    get second() {
        return this.labels.at(1) ?? '';
    }

    get third() {
        return this.labels.at(2) ?? '';
    }
}
